import _AsyncSelect from "./AsyncSelect";
import _Select from "./Select";

export const Select = _Select;
export const AsyncSelect = _AsyncSelect;
